/* tslint:disable:forbid-import */
import { orchestratorAction } from 'satcheljs';
/* tslint:enable:forbid-import */
import saveOrDiscardOptions from '../utils/saveOrDiscardOptions';

export const discardOptions = orchestratorAction('discardOptions', function discardOptions() {
    saveOrDiscardOptions(false);
});
